
import { Vue, Component, Watch } from 'vue-property-decorator';
import SearchBar from '../components/SearchBar.vue';
import VoteList from '../components/VoteList.vue';
@Component({
  components: {
    SearchBar,
    VoteList,
  },
})
export default class List extends Vue {
  searchText = '请输入作者或作品名称';
  mounted() {}
  // @Watch('id')
  // handleId(newval: any, oldval: any) {
  //   if (newval !== oldval) {
  //     this.id = newval;
  //   }
  // }
}
